const getPositionOptions = (t) => [
    {
        label: t('position_choice_1'),
        value: 'Intern',
    },
    {
        label: t('position_choice_2'),
        value: 'Staff',
    },
    {
        label: t('position_choice_3'),
        value: 'Manager',
    },
    {
        label: t('position_choice_4'),
        value: 'Director',
    },
    {
        label: t('position_choice_5'),
        value: 'Executive',
    },
    {
        label: t('position_choice_6'),
        value: 'Consultant',
    },
    {
        label: t('position_choice_7'),
        value: 'Owner',
    },
    {
        label: t('position_choice_8'),
        value: 'Professionals',
    },
    {
        label: t('position_choice_9'),
        value: 'N/A',
    },
];

export default getPositionOptions;
